/* ab-w-series-product-selections.js
USED BY: ab-w-series-options.liquid

PURPOSE: shows additional w series selections and options to create a variation of the product.

NOTE: product part number is set in the ab-w-series-options.liquid file and used here in js
productPartNum - mfg part #
*/

let polarCheck = "";
let optionsCheck = "";

// set image urls
const hwOptionFF = "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W-SERIES-HW_OPTION_FF.png?v=1740249770";
const hwOptionFM = "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W-SERIES-HW_OPTION_FM.png?v=1740249770";
const hwOptionMM = "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W-SERIES-HW_OPTION_MM.png?v=1740249770";

// store all keying images in a array so we can grab the value by code value (ex. W07 in polarization section)
let polarImgArray = {
  W01 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W01.png?v=1740254085",
  W02 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W02.png?v=1740254084",
  W03 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W03.png?v=1740254084",
  W04 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W04.png?v=1740254084",
  W05 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W05.png?v=1740254084",
  W06 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W06.png?v=1740254085",
  W07 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W07.png?v=1740254084",
  W08 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W08.png?v=1740254085",
  W09 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W09.png?v=1740254084",
  W10 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W10.png?v=1740254084",
  W11 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W11.png?v=1740254084",
  W12 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W12.png?v=1740254084",
  W13 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W13.png?v=1740254084",
  W14 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W14.png?v=1740254084",
  W15 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W15.png?v=1740254084",
  W16 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W16.png?v=1740254085",
  W17 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W17.png?v=1740254085",
  W18 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W18.png?v=1740254084",
  W19 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W19.png?v=1740254085",
  W20 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W20.png?v=1740254084",
  W21 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W21.png?v=1740254085",
  W22 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W22.png?v=1740254085",
  W23 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W23.png?v=1740254085",
  W24 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W24.png?v=1740254085",
  W25 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W25.png?v=1740254085",
  W26 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W26.png?v=1740254085",
  W27 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W27.png?v=1740254084",
  W28 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W28.png?v=1740254085",
  W29 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W29.png?v=1740254085",
  W30 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W30.png?v=1740254085",
  W31 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W31.png?v=1740254084",
  W32 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W32.png?v=1740254085",
  W33 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W33.png?v=1740254084",
  W34 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W34.png?v=1740254084",
  W35 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W35.png?v=1740254085",
  W36 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W36.png?v=1740254084",
  W37 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W37.png?v=1740254084",
  W38 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W38.png?v=1740254085",
  W39 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W39.png?v=1740254084",
  W40 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W40.png?v=1740254085",
  W41 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W41.png?v=1740254084",
  W42 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W42.png?v=1740254084",
  W43 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W43.png?v=1740254084",
  W44 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W44.png?v=1740254084",
  W45 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W45.png?v=1740254084",
  W46 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W46.png?v=1740254084",
  W47 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W47.png?v=1740254084",
  W48 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W48.png?v=1740254085",
  W49 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W49.png?v=1740254084",
  W50 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W50.png?v=1740254084",
  W51 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W51.png?v=1740254084",
  W52 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W52.png?v=1740254084",
  W53 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W53.png?v=1740254084",
  W54 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W54.png?v=1740254085",
  W55 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W55.png?v=1740254084",
  W56 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W56.png?v=1740254084",
  W57 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W57.png?v=1740254084",
  W58 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W58.png?v=1740254085",
  W59 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W59.png?v=1740254084",
  W60 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W60.png?v=1740254084",
  W61 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W61.png?v=1740254085",
  W62 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W62.png?v=1740254085",
  W63 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W63.png?v=1740254085",
  W64 : "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/W64.png?v=1740254085",
};

const hwOptionsSelector = document.querySelector('#hardware-options');
const hwOptionsContainer = document.querySelector('#hwOptionsImg');
const hwPolarSelector = document.querySelector('#polarization');
const hwPolarContainer = document.querySelector('#hwPolarImg');
const optionSelector = document.querySelector('#options');
const optionContainer = document.querySelector('#option-text');

// add event listener for hardware options selection
if (hwOptionsSelector != null){
  hwOptionsSelector.addEventListener('change', function (){
  
    if (hwOptionsSelector.value == 'FF'){
      hwOptionsContainer.innerHTML = '<img class="hw-options-image" src=' + hwOptionFF + ' alt="FF - Two Jacksockets" />';
    } else if (hwOptionsSelector.value == 'FM'){
      hwOptionsContainer.innerHTML = '<img class="hw-options-image" src=' + hwOptionFM + ' alt="FM - Jackset Reversed" />';
    } else if (hwOptionsSelector.value == 'MM'){
      hwOptionsContainer.innerHTML = '<img class="hw-options-image" src=' + hwOptionMM + ' alt="MM - Two Jackscrews" />';
    } else {
      /*hwOptionsContainer.innerHTML = '';*/
      hwOptionsContainer.innerHTML = hwOptionsSelector.value;
    };
    updateVariantName();
  
  });
}


if (productHardwareType == 'SY' || productHardwareType == 'SYL' || productHardwareType == 'SC'){
//  const hwPolarSelector = document.querySelector('#polarization');
//  const hwPolarContainer = document.querySelector('#hwPolarImg');
  
  // add event listener for polarization selection
  if (hwPolarSelector != null){
    hwPolarSelector.addEventListener('change', function (){
      
    if (hwPolarSelector.value != ""){
      const pvalue = hwPolarSelector.value;
      let keyPosName = "";
      if (pvalue.length < 3) {
        keyPosName = "W0" + pvalue.slice(-1);
      } else {
        keyPosName = "W" + pvalue.slice(-2);
      }
        hwPolarContainer.innerHTML = '<img class="hw-options-image" src=' + polarImgArray[keyPosName] + ' alt="' + keyPosName + '" />';
      } else {
        hwPolarContainer.innerHTML = '';
      };
      polarCheck = "Y";
      updateVariantName();
      });
    } else {
    polarCheck = "N";
    }
  }

//const optionSelector = document.querySelector('#options');
//const optionContainer = document.querySelector('#option-text');

// add event listener for polarization selection
if (optionSelector != null){
  optionSelector.addEventListener('change', function (){
    optionsCheck = "Y";
    if (optionSelector.value == '443' || optionSelector.value == '-443'){
        optionContainer.innerHTML = '<div class="option-input"><label class="option-input">Polarizing Pin Location #</label><input class="opt-text-input" type="text" id="pinLoc"  name="properties[Polarizing Pin Location]" form="{{ \'product-form-\' | append: section.id }} minlength="1" maxlength="3" size="5" /></div>';
        const optionInput = document.querySelector('#pinLoc');
        optionInput.addEventListener('input', function (){
        updateVariantName();
      });
    } else if (optionSelector.value == '444' || optionSelector.value == '-444') {
        optionContainer.innerHTML = '<div class="option-input"><label class="option-input">Empty Contact Location #</label><input class="opt-text-input" type="text" id="pinLoc" name="properties[Empty Contact Location]" form="{{ \'product-form-\' | append: section.id }} minlength="1" maxlength="3" size="5" /></div>';
        const optionInput = document.querySelector('#pinLoc');
        optionInput.addEventListener('input', function (){
        updateVariantName();
      });
    } else {
      optionContainer.innerHTML = '';
    };
    updateVariantName();
  });
}

let newPartNumName = "";
// update variant name based on options that are selected
function updateVariantName(){
   newPartNumName = productPartNum;
  if (hwOptionsSelector.value != null){
    newPartNumName = newPartNumName + hwOptionsSelector.value;
  }
  if (hwPolarSelector != null) {
    newPartNumName = newPartNumName + hwPolarSelector.value;
  }
  if (optionSelector != null){
    newPartNumName = newPartNumName + optionSelector.value;
    if (optionSelector.value == '443' || optionSelector.value == '-443' || optionSelector.value == '444' || optionSelector.value == '-444'){
      const optionLoc = document.querySelector('#pinLoc');
      newPartNumName = newPartNumName + "-" + optionLoc.value;
    }
    
  }
  const variantNameContainer = document.querySelector('#variant-name');
  if (newPartNumName != productPartNum){
    variantNameContainer.innerHTML = '<div><h6> <div class="variant-name" id="variant-name"></div>Variant Part #: ' + newPartNumName + '</h6> (' + productPartNum + ') </div>';
    const variantName = document.querySelector('#variant-part-num');
    variantName.value = newPartNumName;
    
  } else {
    variantNameContainer.innerHTML = '';
  }
  
}



